export default function checkPassword (pass) {
    let length = pass.length;
    if(length < 8 || length > 64) {
        return 0;
    }
    let score = 0;
    let charPattern = /[^a-zA-Z]+/;
    let LCasePattern = /[^a-z]+/;
    let UCasePattern = /[^A-Z]+/;
    let numPattern = /[^0-9]+/;
    let dupsPattern = /(.)\1{2,}/;
    let notSymbPattern = /[a-zA-Z0-9]+/;

    let numberCount = pass.replace(numPattern, '').length;
    let charCount = pass.replace(charPattern, '').length;
    let UCCount = pass.replace(UCasePattern, '').length;
    let LCCount = pass.replace(LCasePattern, '').length;
    let symCount = pass.replace(notSymbPattern, '').length;

    // checks if password has numbers but not ONLY numbers
    if(numberCount && numberCount !== length) {
        score++;
    }
    // check if password has uppercase characters
    if(UCCount > 0) {
        score++;
    }
    // check if password has lowercase characters
    if(LCCount > 0) {
        score++;
    }
    // check if password has symbols
    if(symCount > 0) {
        score++;
    }
    // check if password has no repeating characters
    let match;
    match = dupsPattern.exec(pass);
    if(!match) {
        score++;
    }
    // check if password isn't exclusively letters
    if(charCount === length) {
        score--;
    }
    return score;

}


// WEBPACK FOOTER //
// ./resources/assets/js/password_check.js